import React from "react";
import Slider from "react-slick";
import aiibeauty from "../../assets/images/companies/aiibeauty.png";
import calf_furn_store from "../../assets/images/companies/CaliforniaFurnitureStore.webp";
import cherishx from "../../assets/images/companies/cherish-x-logo.png";
import embold from "../../assets/images/companies/embold-logo-horizontal.svg";
import edgemobilitysystem from "../../assets/images/companies/ems-logo.webp";
import pinkarat from "../../assets/images/companies/Pinkarat.webp";
import rockwell from "../../assets/images/companies/Rockwell Razors Logo.svg";
import simplyShoes from "../../assets/images/companies/SIMPLYSHOES_Custom.webp";
import basinSports from "../../assets/images/companies/BasinSports.webp";
import bestBrandFurnitures from "../../assets/images/companies/Best-Brand-Furniture.webp";
import dunkins from "../../assets/images/companies/dunkins.svg";
import leightworks from "../../assets/images/companies/leightworks.webp";
import healthandmed from "../../assets/images/companies/healthandmed.webp";
import wowcup from "../../assets/images/companies/wowcup.webp";
import bearblend from "../../assets/images/companies/bearblend.webp";
import surffur from "../../assets/images/companies/surf-fur.webp";
import clinejewelers from "../../assets/images/companies/clinejewelers.webp";
import reparel from "../../assets/images/companies/reparel-logo.webp";
import mlily from "../../assets/images/companies/mlily-logo.webp";
import adamsbuilt from  "../../assets/images/companies/adamsbuilt-logo.webp";

const Cust = () => {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      { breakpoint: 576, settings: { slidesToShow: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 992, settings: { slidesToShow: 3 } },
      { breakpoint: 1200, settings: { slidesToShow: 4 } },
      { breakpoint: 1400, settings: { slidesToShow: 5 } },
    ],
  };

  return (
    <div
      className="container clients-container my-5"
      x-intersect="$el.classList.add('fadeInUp-parallax')"
    >
      <Slider {...settings}>
        <div   onClick={()=> window.open("https://embold.co/?utm_source=CausalFunnel", "_blank")}>
            <img className="client-logo img-fluid" src={embold} alt="embold company logo" />
        </div>
        <div  onClick={() => window.open("https://www.cafurniturestore.com/?utm_source=CausalFunnel",  "_blank")} >
            <img
              className="client-logo img-fluid"
              src={calf_furn_store}
              alt="california furniture store company logo"
            />
        </div>
        <div  onClick={() => window.open("https://basinsports.com/?utm_source=CausalFunnel",  "_blank")}>
            <img className="client-logo img-fluid" src={basinSports} alt="basinSports company logo" />
        </div>

        <div  onClick={() => window.open("https://edgemobilitysystem.com/?utm_source=CausalFunne",  "_blank")}>
            <img
              className="client-logo img-fluid"
              src={edgemobilitysystem}
              alt="edgemobilitysystem company logo"
            />
        </div>
        <div  onClick={() => window.open("https://getrockwell.com/?utm_source=CausalFunnel",  "_blank")}>
            <img className="client-logo img-fluid" src={rockwell} alt="rockwell company logo" />
        </div>

        <div  onClick={() => window.open("https://www.aiibeauty.com/?utm_source=CausalFunnel",  "_blank")}>
            <img className="client-logo img-fluid" src={aiibeauty} alt=" aiibeauty" />
        </div>
        <div  onClick={() => window.open("https://dunkinsdiamonds.com/?utm_source=CausalFunnel",  "_blank")}>
            <img className="client-logo img-fluid" src={dunkins} alt="dunkinsdiamonds company logo" />
        </div>
        <div  onClick={() => window.open("https://www.bestbrandfurniture.com/?utm_source=CausalFunnel",  "_blank")}>
            <img
              className="client-logo img-fluid"
              src={bestBrandFurnitures}
              alt="bestBrandFurnitures company logo"
            />
        </div>
        <div  onClick={() => window.open("https://cherishx.com/?utm_source=CausalFunnel",  "_blank")}>
            <img className="client-logo img-fluid" src={cherishx} alt="cherishx company logo" />
        </div>
        <div  onClick={() => window.open("https://simplyshoes.com/?utm_source=CausalFunnel",  "_blank")}>
            <img className="client-logo img-fluid" src={simplyShoes} alt="simplyshoes company logo" />
        </div>

        <div  onClick={() => window.open("https://www.pinkarat.ca/?utm_source=CausalFunnel",  "_blank")}>
            <img className="client-logo img-fluid" src={pinkarat} alt="pinkarat company logo" />
        </div>
        <div  onClick={() => window.open("https://leightworks.com/?utm_source=CausalFunnel",  "_blank")}>
            <img className="client-logo img-fluid" src={leightworks} alt="leightworks company logo" />
        </div>
        <div  onClick={() => window.open("https://www.healthandmed.com/?utm_source=CausalFunnel",  "_blank")}>
            <img className="client-logo img-fluid" src={healthandmed} alt="healthandmed company logo" />
        </div>
        <div  onClick={() => window.open("https://wowcup.com/?utm_source=CausalFunnel",  "_blank")}>
            <img className="client-logo img-fluid" src={wowcup} alt="wowcup company logo" />
        </div>
        <div  onClick={() => window.open("https://bearblend.com/?utm_source=CausalFunnel",  "_blank")}>
            <img className="client-logo img-fluid" src={bearblend} alt="bearblend company logo" />
        </div>
        <div  onClick={() => window.open("https://www.surf-fur.com/?utm_source=CausalFunnel",  "_blank")}>
            <img className="client-logo img-fluid" src={surffur} alt="surf-fur company logo" />
        </div>
        <div  onClick={() => window.open("https://www.clinejewelers.com/?utm_source=CausalFunnel",  "_blank")}>
            <img className="client-logo img-fluid" src={clinejewelers} alt="clinejewelers company logo" />
        </div>

        <div  onClick={() => window.open("https://mlilyusa.com/?utm_source=CausalFunnel",  "_blank")}>
            <img className="client-logo img-fluid" src={mlily} alt="mlily company logo" />
        </div>
        <div  onClick={() => window.open("https://www.adamsbuiltfishing.com/?utm_source=CausalFunnel",  "_blank")}>
            <img className="client-logo img-fluid" src={adamsbuilt} alt="adamsbuilt company logo" />
        </div>
        <div  onClick={() => window.open("https://www.reparel.com/?utm_source=CausalFunnel",  "_blank")}>
            <img className="client-logo img-fluid" src={reparel} alt="reparel company logo" />
        </div>
      </Slider>
    </div>
  );
};

export default Cust;
